import { DOCUMENT, Injectable, computed, inject, signal } from '@angular/core';

import { DescriptorEntorno } from './entorno.model';
import { resolverEntorno } from './entorno';

/** Nombre del `<meta>` con el que un despliegue se declara. Ver `index.html`. */
export const META_ENTORNO = 'erp-entorno';

/**
 * Fuente única de verdad del entorno en el que corre la web.
 *
 * <h3>Se resuelve UNA vez, en la construcción</h3>
 * Ni el origen ni el `<meta>` cambian mientras la página vive, así que recalcularlo solo daría
 * ocasión de que dos consumidores vieran cosas distintas. Y resolverlo en la construcción —no en un
 * `fetch`— es lo que permite que el chip, el título y el favicon estén puestos **antes del primer
 * pintado**: no hay un instante en el que la app se vea sin marca, que es justo el instante en el
 * que uno mira la pantalla y decide si toca.
 */
@Injectable({ providedIn: 'root' })
export class EntornoService {
  private readonly documento = inject(DOCUMENT);

  private readonly resuelto = signal<DescriptorEntorno>(this.resolver());

  /** El entorno de esta pestaña. */
  readonly descriptor = this.resuelto.asReadonly();

  /** Atajo para lo que más se pregunta: si hay que señalizar algo o no. */
  readonly esProduccion = computed(() => this.resuelto().entorno === 'produccion');

  private resolver(): DescriptorEntorno {
    const origen = this.documento.defaultView?.location.origin ?? '';
    const meta = this.documento.querySelector<HTMLMetaElement>(`meta[name="${META_ENTORNO}"]`);
    return resolverEntorno(origen, meta?.content ?? null);
  }
}
